import { Search, Filter } from "lucide-react";
import { ROLE_OPTIONS } from "./visitorMeta";

export default function VisitorFiltersBar({ q, setQ, roleFilter, setRoleFilter }) {
    return (
        <div className="flex items-center gap-3 flex-wrap">
            <div className="relative flex-1 min-w-[220px]">
                <Search className="h-4 w-4 text-[#6F6B63] absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Search by name, role, or session…"
                    className="w-full bg-white border border-[#E5DFD3] rounded-full pl-9 pr-4 py-2.5 text-[14px] focus:outline-none focus:border-[#0E2A47]"
                    data-testid="visitors-search"
                />
            </div>
            <div className="relative">
                <Filter className="h-4 w-4 text-[#6F6B63] absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
                <select
                    value={roleFilter}
                    onChange={(e) => setRoleFilter(e.target.value)}
                    className="appearance-none bg-white border border-[#E5DFD3] rounded-full pl-9 pr-8 py-2.5 text-[14px] focus:outline-none focus:border-[#0E2A47]"
                    data-testid="visitors-role-filter"
                >
                    {ROLE_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
